
/* styles */
require("!!../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-bde06114\",\"scoped\":false,\"hasInlineConfig\":false}!autoprefixer-loader!less-loader!../node_modules/vue-loader/lib/selector?type=styles&index=0!../node_modules/iview-loader/index.js??ref--0-1!./app.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!../node_modules/iview-loader/index.js??ref--0-1!./app.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-bde06114\"}!../node_modules/vue-loader/lib/selector?type=template&index=0!../node_modules/iview-loader/index.js??ref--0-1!./app.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/home/lw8dl1214/actions-runner/_work/AMA-Application-Portal/AMA-Application-Portal/src/app.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] app.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bde06114", Component.options)
  } else {
    hotAPI.reload("data-v-bde06114", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app.vue
// module id = 98
// module chunks = 18